import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import defaultDisaster from "./defaultDisaster"; // メニューで設定した災害名称保持
import cognito from "./cognito";
// API結果の生データ
import allArea from "./allAreaStore";
import allAreaWithNational from "./allAreaWithNationalStore";
import authorityCheck from "./authorityCheckStore";
import disasterDelivery from "./disasterDeliveryStore";
import disasterDeliveryDetail from "./disasterDeliveryDetailStore";
import disasterInfo from "./disasterInfoStore";
import facilityEvaInfo from "./facilityEvaInfoStore";
import facility from "./facilityStore";
import lodineDistribution from "./lodineDistributionStore";
import screenAuthority from "./screenAuthorityStore";
import vulFacilityStatus from "./vulFacilityStatusStore";
import evaFacilityStatus from "./evaFacilityStatusStore";
import organizeMst from "./organizeMstStore";
import opeAuthMst from "./opeAuthMstStore";
import opeauthgpMst from "./opeauthgpMstStore";
import disasterStaffMst from "./disasterStaffMstStore";
import fixedPhrase from "./fixedPhraseStore";
import fileS3Url from "./fileS3UrlStore";
import car from "./carStore";
import carOperator from "./carOperatorStore";
import equipment from "./equipmentStore";
import equipmentMountMan from "./equipmentMountManStore";
import carMountEquipment from "./carMountEquipmentStore";
import inspectionResult from "./inspectionResultStore";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    defaultDisaster,
    allArea,
    allAreaWithNational,
    authorityCheck,
    disasterDelivery,
    disasterDeliveryDetail,
    disasterInfo,
    facilityEvaInfo,
    facility,
    lodineDistribution,
    screenAuthority,
    cognito,
    vulFacilityStatus,
    evaFacilityStatus,
    organizeMst,
    opeAuthMst,
    opeauthgpMst,
    disasterStaffMst,
    fixedPhrase,
    fileS3Url,
    car,
    carOperator,
    equipment,
    equipmentMountMan,
    carMountEquipment,
    inspectionResult
  },
  plugins: [
    createPersistedState({
      key: process.env.VUE_APP_SESSION_STORAGE_KEY,
      paths: ["defaultDisaster", "screenAuthority"],
      storage: window.sessionStorage
    })
  ]
});
